import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'parseName',
})

/**
 * get the first and last name
 */
export class ParseNamePipe implements PipeTransform {
    transform(fullName: string): { firstname: string, lastname: string } {
        // If null or undefined, return empty names
        if (!fullName) {
            return { firstname: '', lastname: '' };
        }

        let firstname = fullName.trim().split(' ').slice(0, -1).join(' '); // First element is the first name
        let lastname = fullName.trim().split(' ').slice(-1).join(' '); // Last element is the last name
        if(firstname == ''){
            firstname = lastname;
            lastname = '';
        }
        return { firstname, lastname };
    }
}
